import { ref } from 'vue'

export interface BasicSettings {
  [key: string]: any
}

export function useBasicSettings() {
  const settings = ref<BasicSettings>({})
  const loading = ref(false)
  const error = ref<string | null>(null)

  /**
   * 获取基础设置
   * @param lang 语言代码（如 'zh-CN', 'en-US'）
   */
  const fetchBasicSettings = async (lang = 'zh-CN') => {
    loading.value = true
    error.value = null
    
    try {
      const response = await fetch(`/api/admin/settings/basic?lang=${lang}`)
      const data = await response.json()
      
      if (data.success) {
        settings.value = data.data
      } else {
        throw new Error(data.message || '获取基础设置失败')
      }
    } catch (err) {
      error.value = err instanceof Error ? err.message : '获取基础设置失败'
      console.error('[useBasicSettings] Error:', err)
    } finally {
      loading.value = false
    }
  }

  /**
   * 获取指定键的设置值
   * @param key 设置键名
   * @param defaultValue 默认值
   */
  const getSetting = <T = any>(key: string, defaultValue: T | null = null): T | null => {
    return settings.value[key] ?? defaultValue
  }

  return {
    settings,
    loading,
    error,
    fetchBasicSettings,
    getSetting
  }
}